// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"3ed530b5","402":"ce8e6803","612":"75feef0f","673":"37eb20b5","854":"a615f779","903":"d2d99678","924":"4cd1de16"}[chunkId] + ".chunk.js";
};